
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/gear-values",
      function () {
        return require("private-next-pages/m/gear-values.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/gear-values"])
      });
    }
  